import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';
import { Usd1Currency, UsdtCurrency, UsdtPrecision } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

import { competitionBunja } from '../../bunja';

export const EndedPrize = () => {
  const t = useTranslations();
  const { competitionAtom } = useBunja(competitionBunja);
  const competition = useAtomValue(competitionAtom);
  if (!competition) return null;
  const prizePoolCurrency = competition.competitionUrl === 'usd1-perps-trading-battle' ? Usd1Currency : UsdtCurrency;
  return (
    <div className={vstack({ gap: 16, p: 16, bg: 'background.default.level-3' })}>
      <p className={css({ textStyle: 'Text/M/Strong', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Total_prize_pool' />
      </p>
      <p className={css({ textStyle: 'Title/S/Monospace', color: 'inverse.white' })}>
        {competition.milestone && competition.milestone.length > 0 && t('Autogen_common.r251126.s_Up_to')}
        {numberFormatter(competition.prizePool, { precision: UsdtPrecision })} {prizePoolCurrency}
      </p>
    </div>
  );
};
